/**
 * gbi-shine — mouse-tracked radial gradient overlay.
 *
 * Usage: add [data-shine] to any container. The container should be position:relative
 * (or absolute) — the overlay is appended as an absolute-positioned child.
 *
 * Optional:
 *   data-shine-color = "rgba(r,g,b,a)" (default: rgba(255,255,255,0.15))
 *   data-shine-size  = "<percent>"     (default: 50)
 *   data-shine-blend = "<blend-mode>"  (default: overlay)
 *
 * Disabled on touch devices and with prefers-reduced-motion.
 */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isTouch = matchMedia('(hover: none)').matches;
  if (reduceMotion || isTouch) return;

  function attach(el) {
    const color = el.getAttribute('data-shine-color') || 'rgba(255,255,255,0.15)';
    const size = el.getAttribute('data-shine-size') || '50';
    const blend = el.getAttribute('data-shine-blend') || 'overlay';

    const overlay = document.createElement('div');
    overlay.className = 'gbi-shine-overlay';
    overlay.style.cssText = `
      position: absolute;
      inset: 0;
      pointer-events: none;
      opacity: 0;
      mix-blend-mode: ${blend};
      transition: opacity 400ms ease;
      will-change: opacity, background;
      border-radius: inherit;
    `;
    el.appendChild(overlay);

    let rafScheduled = false;
    let nextX = 50, nextY = 50;

    function apply() {
      rafScheduled = false;
      overlay.style.background = `radial-gradient(circle at ${nextX}% ${nextY}%, ${color} 0%, transparent ${size}%)`;
    }

    function onMove(e) {
      const r = el.getBoundingClientRect();
      nextX = ((e.clientX - r.left) / r.width) * 100;
      nextY = ((e.clientY - r.top) / r.height) * 100;
      if (!rafScheduled) {
        rafScheduled = true;
        requestAnimationFrame(apply);
      }
    }

    el.addEventListener('mouseenter', () => { overlay.style.opacity = '1'; });
    el.addEventListener('mousemove', onMove);
    el.addEventListener('mouseleave', () => { overlay.style.opacity = '0'; });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-shine]:not([data-shine-init])').forEach((el) => {
      el.setAttribute('data-shine-init', '');
      attach(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (e) => init(e.target));

  window.GBI = window.GBI || {};
  window.GBI.shine = { init };
})();
